export default __webpack_public_path__ + "static/media/francheville17.9497ff97.jpg";